// extracted by mini-css-extract-plugin
export default {"meshbotDeleteWrapper":"MeshbotDelete_meshbotDeleteWrapper__2zJSG","disabled":"MeshbotDelete_disabled__cBNCs"};